module.exports = ".parallax-body {\n  height: 100%;\n  margin: 0;\n  font: 400 15px/1.8 \"Lato\", sans-serif;\n  color: #777; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/home-component/home-component.component.scss
// module id = ./src/components/home-component/home-component.component.scss
// module chunks = main